import { FC, useRef } from 'react';
// 组件
import { ProPagination } from '../../antd';
// 常量
import { PaginationProps } from 'antd/lib/pagination';

export interface TablePaginationProps extends PaginationProps {
  onChange: (pagination: any) => void;
}
/** 表格分页 */
const TablePagination: FC<TablePaginationProps> = props => {
  const { onChange, pageSize, total, current, ...resProps } = props;
  const currentPagesize = useRef(pageSize);
  const handleChange = (page: number, pageSize?: number) => {
    const params: any = { current: page, pageSize };
    if (currentPagesize.current !== pageSize) {
      currentPagesize.current = pageSize;
      params.current = 1;
      params.pageSize = pageSize;
    }
    onChange(params);
  };
  const startNum = ((current || 1) - 1) * (pageSize || 20) + 1;
  const endNum = (current || 1) * (pageSize || 20);
  if (!total) return null;
  
  return (
    <>
      <div className="yb-table-pagination">
        <div>
          第 {startNum}-{endNum > total ? total : endNum} 条/总共 {total} 条
        </div>
        <ProPagination
          pageSize={pageSize}
          total={total}
          current={current}
          {...resProps}
          onChange={handleChange}
          showQuickJumper={true}
        />
      </div>
    </>
  );
};

export default TablePagination;
